import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";

/**
 * Borderless glass stat card for the dashboard surfaces.
 * Optional `to` makes the whole card a link.
 */
export const StatCard = ({ icon: Icon, label, value, sub, to, testId }) => {
  const inner = (
    <Card className="h-full border-0 p-5" data-testid={testId}>
      <div className="flex items-center justify-between gap-3">
        <span className="text-sm font-[500] text-muted-foreground">{label}</span>
        {Icon && (
          <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-primary">
            <Icon className="h-4 w-4" />
          </span>
        )}
      </div>
      <div className="mt-3 text-3xl font-[700] tracking-[-0.02em] text-foreground">{value}</div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </Card>
  );
  return to ? (
    <Link to={to} className="block focus:outline-none">{inner}</Link>
  ) : (
    inner
  );
};
